import React, { useMemo } from "react";
import "./ProjectHeader.scss";
import { useSelector } from "react-redux";
import { breadCrumbsArray } from "../../../../data/breadCrumbs";
import { Link, matchPath } from "react-router-dom/cjs/react-router-dom";
import { ConditionalRender } from "../../../shared/ConditionalRender/ConditionalRender";

const ProjectHeader = ({ handleNavigation, showBack = true }) => {
  const dynamicBreadCrumbs = useSelector(
    (state) => state.projects.dynamicBreadCrumbs,
  );
  const generateBreadCrumbs = () => {
    for (let key of Object.keys(breadCrumbsArray).reverse()) {
      let pathDetails = matchPath(pathname, key);
      if (pathDetails) {
        document.title = `Art of Scale | ${breadCrumbsArray[key][0].title}`;
        return dynamicBreadCrumbs[key] || breadCrumbsArray[key];
      }
    }
    return [];
  };
  const { pathname } = window.location;

  const breadCrumbs = useMemo(generateBreadCrumbs, [
    pathname,
    dynamicBreadCrumbs,
  ]);
  const renderBreadcrumbs = () => {
    return breadCrumbs.map((breadCrumb, index) => {
      if (index !== breadCrumbs.length - 1) {
        return (
          <div
            className="d-none d-md-flex d-md-flex breadcrumb breadcrub-previous"
            key={index}
          >
          {/* ⚠️ A crumb with NO url renders as TEXT, not a link. Several
              Execution Blueprint trails deliberately carry inert crumbs — a
              company name, or a stage the user is not allowed to navigate back
              to — and `<Link to="">` does not stay put: react-router resolves
              an empty target to the app ROOT, so those crumbs were quietly
              sending people to the home page. */}
          {breadCrumb.url ? (
            <Link to={breadCrumb.url}>{breadCrumb.title}</Link>
          ) : (
            <span>{breadCrumb.title}</span>
          )}
            <div>
              <img
                src="/assets/images/left-icon-dark.svg"
                className="mx-2"
                alt="right_arrow"
              />
            </div>
          </div>
        );
      }
      return (
        <div
          className="d-flex d-md-flex d-md-flex breadcrumb active flex-grow-1 mb-0"
          key={index}
        >
          {index === 0 ? null : (
            // Hidden rather than rendered inert when the previous crumb has
            // no url: a back chevron that does nothing is worse than no
            // chevron, and on these trails the browser's own back button is
            // the way back.
            breadCrumbs[index - 1].url ? (
              <div className="d-md-none d-lg-none mx-2 cursor-pointer">
                <Link to={breadCrumbs[index - 1].url}>
                  <img src="/assets/images/left-icon-dark.svg" alt="left" />
                </Link>
              </div>
            ) : null
          )}
          <div className="d-flex align-items-center breadcrub-main">
            <span className="mt-0 breadcrumb-title">{breadCrumb.title}</span>
          </div>
        </div>
      );
    });
  };
  return (
    <div id="project-header" className="d-flex align-items-center px-3">
      <ConditionalRender condition={showBack}>
        <div
          className="d-flex align-items-center cursor-pointer"
          onClick={handleNavigation}
        >
          <img
            src="/assets/images/back.svg"
            height={15}
            width={20}
            className="back-icon"
          />
          <span className="dark-grey ms-2">Back</span>
        </div>
      </ConditionalRender>

      <div
        className={`w-100 d-flex align-items-center ${showBack ? "ms-3" : ""}`}
      >
        {renderBreadcrumbs()}
      </div>
    </div>
  );
};

export default ProjectHeader;
